var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "price-format", style: `color:${_vm.color};` },
    [
      _vm._t("left"),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "unit", style: `font-size:${_vm.fracSize}px` },
        [_vm._v("￥")]
      ),
      _c("span", { staticClass: "int", style: `font-size:${_vm.intSize}px` }, [
        _vm._v(_vm._s(_vm.intOfPrice)),
      ]),
      _c(
        "span",
        { staticClass: "dec", style: `font-size:${_vm.decimalOfPriceSize}px` },
        [_vm._v(_vm._s(_vm.decimalOfPrice))]
      ),
      _vm._v(" "),
      _vm._t("right"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }